export const DEFAULT_PRICE_FILTER = '*_49.99';
export const FILTERABLE_PARAM_PREFIX = 'f_';
export const ID_FILTER = 'id';
export const PRICE_FILTER = 'price';
export const QUANTITY_FILTER = 'quantity';
export const SORT_FILTER = 'sort';
export const SOURCE_FILTER = 'source';

export const FILTERS_TO_IGNORE_FROM_SUMMARY = {
  '/popular-gifts': [PRICE_FILTER, SOURCE_FILTER],
  '/search': [SOURCE_FILTER],
};
export const NO_PREFIX_FILTERS = [
  ID_FILTER,
  SORT_FILTER,
  QUANTITY_FILTER,
  SOURCE_FILTER,
];
export const NO_FILTER_QUERY_PARAMS = [SOURCE_FILTER];
